




































import Vue from 'vue';
import Component from 'vue-class-component';
import { mdiChevronDoubleLeft, mdiChevronDoubleRight } from '@mdi/js';

const Props = Vue.extend({
	props: {
		page: {
			type: Number,
			required: true
		},
		pageCount: {
			type: Number,
			required: true
		}
	}
});

@Component({
	model: {
		prop: 'page',
		event: 'change'
	}
})
export default class Pagination extends Props {

	firstPageIcon = mdiChevronDoubleLeft;
	lastPageIcon = mdiChevronDoubleRight;

	get firstPageIsDisable(): boolean {
		return this.page === 1;
	}

	get lastPageIsDisable(): boolean {
		return this.page === this.pageCount;
	}

	get computedValue(): number {
		return this.page;
	}

	set computedValue(value: number) {
		this.$emit('change', value);
	}

	goFirstPage(): void {
		this.computedValue = 1;
	}

	goLastPage(): void {
		this.computedValue = this.pageCount;
	}
}
